import type { ViewConfigWithMetric } from '@salescore/core'
import { Struct } from 'effect'

import type { StateTransformer } from '../binder'

export const hasCustomSearchQuery = (searchQuery: string | undefined): boolean =>
  searchQuery !== undefined && searchQuery !== ''

// The curried shape prevents callers from capturing a stale config snapshot before dispatch.
export const clearCustomSearchQuery = (): StateTransformer<ViewConfigWithMetric> => (previous) =>
  previous.type !== 'sheet' || previous.meta === undefined
    ? previous
    : {
        ...previous,
        meta: Struct.omit(previous.meta, ['searchQuery']),
      }
